import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { IconTimesCircle } from "../icons/IconTimesCircle";
import { useMprcTheme } from "../MprcThemeProvider";

interface IButtonProps extends MprcButtonProps {
    showIcon?: boolean;
}

export const ButtonDelete: React.FC<IButtonProps> = ({ title, text, color = "error", showIcon = true, ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonDelete.text;
    const lTitle = title || theme.buttons.ButtonDelete.title;
    return (
        <MprcButton
            {...rest}
            color={color}
            title={lTitle}
            text={lText}
            startIcon={showIcon && <IconTimesCircle fixedWidth />}
        />
    );
};
